<div class="mt-8 mb-4">

    @let myRoles = myRoles$ | async;

    <div class="w-full flex flex-row justify-between mb-4 border-b border-blueGray-100">
        <app-btn-back routeTo=".."></app-btn-back>
        @if (myRoles?.admin && group?.memberStatus == membershipStatus.active) {
        <app-btn-route [routeTo]="'edit'" [btnText]="'Edit'" [icon]="'fa fa-edit'"
            [colors]="'bg-primary-500 active:bg-primary-300 hover:bg-primary-300 disabled:bg-primary-200 text-white'"></app-btn-route>
        }
    </div>

    <!-- Title and Status Header -->
    <div class="flex flex-col gap-2 border-b border-blueGray-100 mb-6">
        <h1 class="font-semibold text-2xl flex text-primary-500">
            {{prayer?.subject}}
        </h1>
        <div class="flex flex-row justify-between items-center">
            <app-chip label="#{{prayer?.category}}"></app-chip>
            <app-btn-prayer-status [status]="prayer?.status"
                [isDisabled]="!myRoles?.admin && group?.memberStatus != membershipStatus.active"
                (click)="changeStatusDialog()"></app-btn-prayer-status>
        </div>
    </div>

    <!-- Content Columns -->
    <div class="flex flex-col lg:flex-row gap-8 w-full">
        <!-- Main Column: Description and Timeline -->
        <div class="flex-1 lg:max-w-3xl flex flex-col gap-8">

            <!-- Description -->
            <div class="flex flex-col gap-2">
                <span class="text-xs font-bold uppercase tracking-wider text-blueGray-400">Description</span>
                <p class="text-blueGray-700 text-base whitespace-pre-line leading-relaxed">
                    {{prayer?.description}}
                </p>
            </div>

            <!-- Timeline -->
            @if (prayer?.updates && prayer!.updates.length > 0) {
            <div class="flex flex-col gap-4 mt-4 border-t border-blueGray-100">
                <span class="text-xs font-bold uppercase tracking-wider text-blueGray-400">Updates / History</span>

                <div class="relative pl-6 border-l-2 border-primary-100 flex flex-col gap-6 ml-3 mt-2">
                    @for (item of prayer?.updates; track $index; let i = $index) {
                    <div class="relative">
                        <!-- Timeline Dot -->
                        <div class="absolute -left-[33px] top-1 w-4 h-4 rounded-full border-2 border-white shadow-sm"
                            [class.bg-primary-500]="i === 0" [class.bg-primary-200]="i !== 0">
                        </div>

                        <!-- Timeline Content -->
                        <div class="flex flex-col gap-1 mt-1">
                            <span class="text-xs text-blueGray-500 font-medium">
                                {{ item.updatedOn.toDate() | moment: 'Do MMM YYYY, hh:mm a' }}
                            </span>
                            <span class="font-normal text-blueGray-700">
                                {{ item.status }}
                            </span>
                        </div>
                    </div>
                    }
                </div>
            </div>
            }
        </div>

        <!-- Sidebar Info Column -->
        <div class="w-full lg:w-4/12 flex flex-col gap-6">
            <div class="flex flex-col gap-4 bg-blueGray-50/50 border border-blueGray-200 rounded-xl p-5">
                <h4 class="text-xs font-bold uppercase tracking-wider text-blueGray-400 mb-2 mt-0">
                    Prayer Details
                </h4>

                <div class="flex flex-col gap-4">
                    <!-- Requested By -->
                    @if (prayer?.requestedBy) {
                    <div class="flex flex-col gap-1">
                        <span class="text-xs font-semibold text-blueGray-500 uppercase tracking-wider">Requested
                            By</span>
                        <span class="text-sm font-bold text-blueGray-800 capitalize">{{prayer?.requestedBy}}</span>
                    </div>
                    }

                    <!-- Expiry Date -->
                    @if (prayer?.expiry) {
                    <div class="flex flex-col gap-1 border-t border-blueGray-100 pt-3">
                        <span class="text-xs font-semibold text-blueGray-500 uppercase tracking-wider">Expiry
                            Date</span>
                        <span class="text-sm font-semibold text-blueGray-700">
                            {{ prayer?.expiry!.toDate() | moment: 'Do MMM YYYY' }}
                        </span>
                    </div>
                    }

                    <!-- Created Date -->
                    @if (prayer?.created) {
                    <div class="flex flex-col gap-1 border-t border-blueGray-100 pt-3">
                        <span class="text-xs font-semibold text-blueGray-500 uppercase tracking-wider">Created On</span>
                        <span class="text-sm text-blueGray-600">
                            {{ prayer?.created!.toDate() | moment: 'Do MMM YYYY' }}
                        </span>
                    </div>
                    }

                    <!-- Last Updated -->
                    @if (prayer?.modified) {
                    <div class="flex flex-col gap-1 border-t border-blueGray-100 pt-3">
                        <span class="text-xs font-semibold text-blueGray-500 uppercase tracking-wider">Last
                            Updated</span>
                        <span class="text-sm text-blueGray-600">
                            {{ prayer?.modified!.toDate() | moment: 'Do MMM YYYY' }}
                        </span>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>